<template>
    <div>
        <PageHeader/>
        <section id="act_rules">
            <div class="container">
                <div class="row">
                <div class="col-12">
                    <div class="list-wrap">

                    <div class="main-title">
                        <h1>{{all_datas.title}}</h1>
                    </div> 
                    <mylist :rule_datas="all_datas.activity_rules"/>

                    </div>
                </div>
                </div>
            </div>  
            <ToTopBtn/>
        </section>
    </div>
</template>

<script>

import axios from 'axios';

import mylist from './list';
import PageHeader from '../subview/PageHeader.vue';
import ToTopBtn from '../subview/ToTopBtn.vue';




export default {
	components: {
        mylist,
        PageHeader,
        ToTopBtn
	},
	data(){
		return {
			all_datas: "",
			json_src: './src/assets/json/activity_rules.json'

		}
	},
	methods: {
		get_datas() {
            axios.get(this.json_src).then((response) => {
                
                console.log(response.data)
				this.all_datas = response.data;


				// setTimeout(()=>{
					
				// },10);
				
				
				
            }, (error) => {
            	console.log(error)
            })
		}
	},
	mounted(){
        this.get_datas();
        $("HTML, BODY").animate({ scrollTop: 0 }, 500);
        
		
		
	}
}
</script>
<style lang="sass">
section#act_rules
	&:before
        content: ''
        background-image: url('../assets/product-bg.jpg')
        position: fixed
        display: block
        top: 0
        left: 0
        width: 100%
        height: 100%
        background-size: cover
        background-position: center bottom
        transform: translateZ(0)
        will-change: transform
        z-index: -1000
section
    &#act_rules .list-wrap, &#lottery .list-wrap
        padding-top: 50px
        padding-bottom: 50px
    &#act_rules .main-title, &#lottery .main-title
        text-align: center
        padding: 30px 0
    &#act_rules .main-title h1, &#lottery .main-title h1
        font-size: 28px
        font-weight: 400
        letter-spacing: 2px
    &#act_rules .custom-scroller, &#lottery .custom-scroller
        height: 60vh
    &#act_rules .custom-scroller p, &#lottery .custom-scroller p
        margin-bottom: 30px
        letter-spacing: 1px
        text-align: justify
        line-height: 30px
        font-weight: 300
        display: -webkit-box
        display: -ms-flexbox
        display: flex
    &#act_rules .custom-scroller p .num, &#lottery .custom-scroller p .num
        width: 25px
    &#act_rules .custom-scroller p .text, &#lottery .custom-scroller p .text
        text-align: justify
        -webkit-box-flex: 1
        -ms-flex: 1
        flex: 1
    &#act_rules .last-content, &#lottery .last-content
        margin-top: 30px
        text-align: justify
        font-weight: 400
        line-height: 27px
    &#act_rules .last-content .last-c, &#lottery .last-content .last-c
        margin-bottom: 10px
    &#act_rules .last-content .last-c .img-wrap, &#lottery .last-content .last-c .img-wrap
        position: relative
        line-height: 250px
    &#act_rules .last-content .last-c .img-wrap img, &#lottery .last-content .last-c .img-wrap img
        width: 100%
    &#act_rules .locs, &#lottery .locs
        margin-top: 30px
    &#act_rules .locs .loc, &#lottery .locs .loc
        padding: 15px 0
        border-bottom: 1px solid rgba(0, 0, 0, 0.3)
    &#act_rules .locs .loc .info, &#lottery .locs .loc .info
        font-weight: 300
    &#act_rules .locs .loc
        .name, .tel
            max-width: 300px
    &#lottery .locs .loc
        .name, .tel
            max-width: 300px
    &#act_rules .locs .loc .info.addr, &#lottery .locs .loc .info.addr
        max-width: auto
    &#act_rules .locs .loc .info.tel.array, &#lottery .locs .loc .info.tel.array
        max-width: none
    &#act_rules .locs .loc strong, &#lottery .locs .loc strong
        display: none
    &#act_rules .locs .locs-title, &#lottery .locs .locs-title
        font-size: 20px

@media (max-width: 768px)
    section
        &#act_rules .list-wrap, &#lottery .list-wrap
            padding-top: 10px
            padding-bottom: 10px

@media (max-width: 991px)
    section
        &#act_rules .locs .loc strong, &#lottery .locs .loc strong
            display: inline-block

@media (max-width: 991px)
    section
        &#act_rules .locs .info-title, &#lottery .locs .info-title
            display: none

</style>



// WEBPACK FOOTER //
// src/ActRules/main.vue